// extension methods
interface Array<T> {
    updateValues(newValues: Array<T>): void;
    traverse(childSelector: (value: T) => Array<T>): Array<T>
    clear(): void;
}

Array.prototype.updateValues = function <T>(newValues: Array<T>): void {
    this.splice(0, this.length, ...newValues);
};

Array.prototype.clear = function (): void {
    this.splice(0, this.length);
}

Array.prototype.traverse = function <T>(childSelector: (value: T) => Array<T>): Array<T> {
    const newValues = new Array<T>()
    for (let newValue of this) {
        newValues.push(newValue)
        newValues.push(...childSelector(newValue).traverse(childSelector));
    }
    return newValues;
};

// static methods
interface ArrayConstructor {
    range(start: number, end: number, reverse?: boolean): Array<number>;
}

Array.range = function <T>(start: number, end: number, reverse?: boolean): Array<number> {
    const array = Array.from({length: (end - start + 1)}, (v, k) => k + start);
    return reverse ? array.reverse() : array;
}
